// @jait/shared — Surface types
export const SURFACE_TYPES = [
    "terminal",
    "browser",
    "screen-share",
    "screen-capture",
    "voice",
    "file-system",
    "os-control",
    "clipboard",
    "notification",
];
//# sourceMappingURL=surface.js.map